import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import router from '@/router'
import axiosInstance from '@/services'
import { useAuthStore } from '@/stores/auth'

const initForm = () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true',
    showsendOTPForm: false
  }
}

const getAllowedRefundMethods = async () => {
  const formStore = useFormStore()
  const response = await axiosInstance.get('/api/refundRequest/getAllowedRefundMethods')
  if (!response) return
  const { allowedRefundMethodIds = '', requestNumber = '' } = response
  formStore.draft.request = {
    ...formStore.draft.request,
    allowedRefundMethodIds,
    referenceRequestNumber: requestNumber
  }
}

const getCurrentEstablishment = async () => {
  const authStore = useAuthStore()
  if (authStore.user.applicationId != 2) return
  const formStore = useFormStore()
  const response = await axiosInstance.get('/api/establishment/info')
  if (!response) return
  const { licenseIssueDate = '', relatedPerson = [], establishmentCardNumber = '' } = response
  const arr = establishmentCardNumber.split('/') || []
  formStore.draft.request = {
    ...formStore.draft.request,
    establishmentLicenceIssueDate: licenseIssueDate,
    referenceRequestNumber: relatedPerson?.[0]?.unifiedNumber || '',
    establishmentNumber: arr[0] || '',
    establishmentSponsorType: arr[1] || ''
  }
}
export default async function () {
  try {
    await initForm()
    await getAllowedRefundMethods()
    await getCurrentEstablishment()
  } catch (error) {
    console.error('useCancelSubscriptionPreload error: ', error)
  }
}
